import { render, staticRenderFns } from "./FixTabFooterPage.vue?vue&type=template&id=7e20d0fc&scoped=true"
import script from "./FixTabFooterPage.vue?vue&type=script&lang=ts"
export * from "./FixTabFooterPage.vue?vue&type=script&lang=ts"
import style0 from "./FixTabFooterPage.vue?vue&type=style&index=0&id=7e20d0fc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e20d0fc",
  null
  
)

export default component.exports